import React from 'react';

function CreditCard(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M4.5 5.25H19.5C20.1904 5.25 20.75 5.80964 20.75 6.5V8H3.25V6.5C3.25 5.80964 3.80964 5.25 4.5 5.25ZM3.25 9.25V17.5C3.25 18.1904 3.80964 18.75 4.5 18.75H19.5C20.1904 18.75 20.75 18.1904 20.75 17.5V9.25H3.25ZM2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5ZM6 12.625C6 12.2798 6.27982 12 6.625 12H13.375C13.7202 12 14 12.2798 14 12.625C14 12.9702 13.7202 13.25 13.375 13.25H6.625C6.27982 13.25 6 12.9702 6 12.625ZM6.625 14.75C6.27982 14.75 6 15.0298 6 15.375C6 15.7202 6.27982 16 6.625 16H10.375C10.7202 16 11 15.7202 11 15.375C11 15.0298 10.7202 14.75 10.375 14.75H6.625Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default CreditCard;
